import {
  CARRIER_UPLOADED_DOCS_ACTION_TYPES,
  CARRIER_UPLOAD_DOCS_ACTION_TYPES,
  CARRIER_EDIT_UPLOAD_ACTION_TYPES,
} from 'utils/actions/carrier'

const {
  UPLOADED_DOCS_FAILURE,
  UPLOADED_DOCS_REQUEST,
  UPLOADED_DOCS_SUCCESS,
} = CARRIER_UPLOADED_DOCS_ACTION_TYPES

const {
  UPLOAD_DOCUMENTS_FAILURE,
  UPLOAD_DOCUMENTS_REQUEST,
  UPLOAD_DOCUMENTS_SUCCESS,
} = CARRIER_UPLOAD_DOCS_ACTION_TYPES

const { ADD_DOCUMENT, ADD_DOCUMENT_FAILURE, DELETE_DOCUMENT } = CARRIER_EDIT_UPLOAD_ACTION_TYPES

const defaultState = {
  loading: true,
  errors: null,
  documents: [],
  dialogDocuments: [],
}

const carrierDocumentsUploadsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case UPLOADED_DOCS_REQUEST: {
      return {
        ...state,
        loading: true,
        errors: null,
      }
    }
    case UPLOADED_DOCS_SUCCESS: {
      return {
        ...state,
        documents: action.payload.packageFiles,
        dialogDocuments: action.payload.packageFiles,
        loading: false,
        errors: null,
      }
    }
    case UPLOADED_DOCS_FAILURE: {
      const {
        payload: { errors },
      } = action
      return {
        ...state,
        loading: false,
        error: errors,
      }
    }
    case UPLOAD_DOCUMENTS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      }
    }
    case UPLOAD_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        documents: action.payload.packageFiles,
        dialogDocuments: action.payload.packageFiles,
      }
    }
    case UPLOAD_DOCUMENTS_FAILURE: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
      }
    }
    case ADD_DOCUMENT: {
      return {
        ...state,
        loading: false,
        dialogDocuments: [...state.dialogDocuments, ...action.files],
        errors: null,
      }
    }
    case ADD_DOCUMENT_FAILURE: {
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    }
    case DELETE_DOCUMENT: {
      return {
        ...state,
        dialogDocuments: state.dialogDocuments.map(document =>
          document.id === action.id ? { ...document, _destroy: true } : document
        ),
      }
    }
    default:
      return state
  }
}

export default carrierDocumentsUploadsReducer
